import { getViewportInfo } from '@tcp/core/src/utils';

const { width } = getViewportInfo() || {};

const SLIDES_COUNT_PLP = { s1250: 5, s1400: 6, count1: 6, count2: 8, count3: 8 };
const SLIDES_COUNT_HLP = { s1250: 7, count1: 8, count2: 9, count3: 10 };
export const getCarouselConfigResponsiveArray = (numberOfTiles, breakpoints) => {
  return [
    {
      breakpoint: parseInt(breakpoints.medium, 10) - 1,
      settings: {
        slidesToShow: numberOfTiles >= 2.5 ? 2 : numberOfTiles,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: false,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: numberOfTiles >= 5 ? 5 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1499,
      settings: {
        slidesToShow: numberOfTiles >= 6 ? 6 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1650,
      settings: {
        slidesToShow: numberOfTiles >= 7 ? 7 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 1900,
      settings: {
        slidesToShow: numberOfTiles >= 8 ? 8 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 2100,
      settings: {
        slidesToShow: numberOfTiles >= 9 ? 9 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 2300,
      settings: {
        slidesToShow: numberOfTiles >= 10 ? 10 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 2600,
      settings: {
        slidesToShow: numberOfTiles >= 12 ? 12 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
    {
      breakpoint: 2800,
      settings: {
        slidesToShow: numberOfTiles >= 13 ? 13 : numberOfTiles,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
      },
    },
  ];
};

export const getCarouselConfigArray = (breakpoints, slidesToShow) => {
  return [
    {
      breakpoint: breakpoints.large,
      settings: {
        slidesToShow,
        dots: false,
      },
    },
    {
      breakpoint: breakpoints.medium,
      settings: {
        slidesToShow,
        arrows: false,
      },
    },
    {
      breakpoint: breakpoints.small,
      settings: {
        slidesToShow,
        arrows: false,
      },
    },
  ];
};

export const getSlidesToShow = (plpSbc) => {
  let slidesToShow = SLIDES_COUNT_HLP.count1;
  if (width <= 1300) slidesToShow = SLIDES_COUNT_HLP.s1250;
  if (width >= 1600) {
    slidesToShow = SLIDES_COUNT_HLP.count2;
  }
  if (width >= 1920) {
    slidesToShow = SLIDES_COUNT_HLP.count3;
  }
  if (plpSbc) {
    slidesToShow = SLIDES_COUNT_PLP?.count1;
    if (width <= 1400) slidesToShow = SLIDES_COUNT_PLP.s1400;
    if (width <= 1250) slidesToShow = SLIDES_COUNT_PLP.s1250;
    if (width >= 1600) {
      slidesToShow = SLIDES_COUNT_PLP.count2;
    }
    if (width >= 1800) {
      slidesToShow = SLIDES_COUNT_PLP.count3;
    }
  }
  return slidesToShow;
};
